let $slider_adaptive;
let $slider = 0;
let $slider_full = 0;
let $window = $(window);
let $body = $('body');

// Инициализация
mask();
frame('#workshop .frame:not(.active)');
form_validate();

// Инициализация
$('#nav').mmenu({
  'counters': true,
  'extensions': [
    'pagedim-black',
    'theme-dark',
  ],
  'navbars': [

    {
      'position': 'top',
      'content': [
        'searchfield',
      ],
    },
    true,
  ],
  searchfield: {
    placeholder: 'Поиск по разделам',
  },
}, {});

if ($('#slider .bxSlider .item').length > 1) $slider = $('#slider .bxSlider').bxSlider({
  prevText: '',
  nextText: '',
});
if ($('.catalog .full .bxSlider .item').length > 1) $slider_full = $('.catalog .full .bxSlider').bxSlider({
  prevText: '',
  nextText: '',
  infiniteLoop: false,
});

$('.js-slick-slider').each((index, element) => {
  const $this = $(element);
  const data = $this.data('slick-slider');

  $this.slick(data);
});

$('select').chosen();

$('.modal .window').each(function (index, element) {
  $(element).css({ 'margin-top': '-' + $(element).innerHeight() / 2 + 'px', 'top': '50%' });
});

// События
$window.on('resize load', function () {
  var item = $('.context .bxSlider:not(.active)'),
    item_active = $('.context .bxSlider.active');

  // frame_size();
  // $('.frame').sly('reload');
  // Создание слайдера в тексте
  if ($window.width() <= 980 && item.length) {
    $slider_adaptive = item.addClass('active').bxSlider({
      controls: false,
      adaptiveHeight: true,
    });
  }

  if ($window.width() <= 980 && item_active.length) $slider_adaptive.reloadSlider();

  // Удаление слайдеров в тексте
  if ($window.width() > 980 && item_active.length) {
    $slider_adaptive.removeClass('active').destroySlider();
    $('.context .bxSlider').removeAttribute('style');
  }
  // Перазагрузка слайдера
  if ($slider !== 0) $slider.reloadSlider();
  if ($slider_full !== 0) $slider_full.reloadSlider();
});

// Клик
$body.on('click', '[data-click]', function () {
  var data = $(this).data('click');

  actions(data, this);
  if ($(this).is('a')) return false;
});

// Отправка формы
$body.on('submit', '[data-submit]', function () {
  var data = $(this).data('submit');

  actions(data, this, serialize);
});

// Изменение формы
$body.on('change', 'form[data-form-change] select', function () {
  var data = $(this).parents('form').data('form-change');

  var serialize = $(this).parents('form').serialize();
  actions(data, this, serialize);
});

// Закладки
$body.on('click', '.tabs li a', function () {
  var $this = $(this).parent();

  $this.addClass('active').siblings().removeClass('active');
  $($this.data('tab')).slideDown('fast').siblings().slideUp('fast');
});

// Функции
// Маски
function mask() {
  $('[data-mask=phone]').mask('+7(999) 999-9999');
}

// Полосы прокрутки
function frame(selector) { // .frame.:not(.active)
  $(selector).each(function (index, element) {
    var $frame = $(element),
      $wrap = $frame.parent(),
      $scrollbar = $wrap.find('.scrollbar'),
      $items = $frame.find('.item'),
      $prev = $wrap.find('.controls .prev'),
      $next = $wrap.find('.controls .next');

    $frame.addClass('active').sly({
      horizontal: 1,
      itemNav: $frame.data('array').itemNav,
      smart: 1,
      activateMiddle: ($frame.data('array').itemNav ? 1 : null),
      activateOn: 'click',
      mouseDragging: 1,
      touchDragging: 1,
      releasSwing: 1,
      startAt: ($frame.data('array').itemNav === 'forceCentered' ? Math.round($items.length / 2) - 1 : 0),
      scrollBar: ($scrollbar.length ? $scrollbar : null),
      scrollBy: ($scrollbar.length ? 1 : null),
      speed: 300,
      elasticBounds: 1,
      easing: 'easeOutExpo',
      dragHandle: 1,
      dynamicHandle: 1,
      clickBar: 1,
      pagesBar: ($wrap.find('.pages').length ? $wrap.find('.pages') : null),

      // Buttons
      prev: ($prev.length ? $prev : null),
      next: ($next.length ? $next : null),
    }).init();
  });
}

function frame_size() {
  // Изменение размеров слайдов каталога
  $('.catalog .frame').each(function (index, element) {
    var $frame = $(element),
      $item = $frame.find('.item');

    if ($frame.data('array').full && $window.width() <= 505) {
      $item.innerWidth($frame.width());
      frame('.catalog .frame');
    } else {
      $('.catalog .frame').sly(false);
      $item.removeAttr('style').removeClass('active');
    }
  });
}

// Действия
function actions(data, $this, serialize) {

  for (var selector in data) {
    var $selector = $(selector);

    if (data[selector].class) $selector.toggleClass(data[selector].class);
    if (data[selector].removeClass) $selector.removeClass(data[selector].removeClass);
    if (data[selector].addClass) $selector.addClass(data[selector].addClass);
    if (data[selector].click === 'true') $selector.click();
    if (data[selector].text) $selector.text(data[selector].text);
    if (data[selector].remove) $selector.remove();
    if (data[selector].removeAttr) $selector.removeAttr(data[selector].removeAttr);
    if (data[selector].alignTop) $(selector).css({
      'margin-top': '-' + $(selector).innerHeight() / 2 + 'px',
      'top': '50%',
    });
    if (data[selector].poscursor) $(selector).css({
      'top': $($this).offset().top + $($this).outerHeight() / 2 - $(selector).height() / 2 + 'px',
      'left': $($this).offset().left + $($this).outerWidth() + 40 + 'px',
    });
    if (data[selector].toggle) {
      switch (data[selector].toggle) {
        case 'slide':
          $selector.slideToggle('fast');
          break;
        case 'slideUp':
          $selector.slideUp('fast');
          break;
        case 'slideDown':
          $selector.slideDown('fast');
          break;
        case 'fade':
          $selector.fadeToggle('fast');
          break;
        case 'fadeIn':
          $selector.fadeIn('fast');
          break;
        case 'fadeOut':
          $selector.fadeOut('fast');
          break;
      }
    }
    if (data[selector].scroll) {
      var offset = $selector.offset().top;
      if (data[selector].scroll != 'true') offset = $selector.offset().top - parseInt(data[selector].scroll);
      $body.animate({ scrollTop: offset });
    }
    if (data[selector].ajax) {
      var url = (data[selector].ajax.url ? data[selector].ajax.url : $(data[selector]).attr('href'));
      if (serialize) url = url + '?' + serialize;

      $.ajax({
        url: url,
        type: (data[selector].ajax.type ? data[selector].ajax.type : 'GET'),
        data: data[selector].ajax.data ? data[selector].ajax.data : { isNaked: 1 },
        success: function (response) {
          if (data[selector].ajax.selector === 'this') $selector.html(response);
          else {
            if ($(data[selector].ajax.selector).length) $(data[selector].ajax.selector).html(response);
          }

          form_validate();
          mask();
        },
      });
    }
  }
}

// Проверка форм
function form_validate() {
  $('form.validate:not(.active)').each(function (index, element) {
    var array = { warnText: null, response: null },
      data = $(element).data('submit'),
      dataSuccess = $(element).data('submit-success');

    array = $(element).data('array') || array;
    $(element).addClass('active').validate({
      // Форма заполнена не верно
      invalidHandler: function () {
        $(element).ajaxSubmit({
          data: { isNaked: 1 },
          success: function (response, status, xhr, Form) {
            var
              warnText = $(response).filter('.warnText'),
              all = $(response);

            if (warnText.length && warnText.length !== 'false') {
              if (array.warnText != null) $(array.warnText).html(warnText);
              else $(Form).find('.warnText').html(warnText);
            } else {
              if (array.warnText != null) $(array.warnText).html(all);
              else $(Form).find('.warnText').html(all);
            }
            actions(data);
          },
        });
      },
      // Форма заполнена верно
      submitHandler: function (form) {
        if (array.ajax !== 'false') {
          $(form).ajaxSubmit({
            data: { isNaked: 1 },
            success: function (response, status, xhr, Form) {
              var
                resp = ($(response).filter('.response').length ? $(response).filter('.response') : $(response).find('.response')),
                warnText = ($(response).filter('#nc_modal_status').length ? $(response).filter('#nc_modal_status') : $(response).find('#nc_modal_status')),
                all = $(response);

              if (warnText.length) {
                if (warnText.length && warnText.length !== 'false') {
                  if (array.warnText != null) $(array.warnText).html(warnText);
                  else $(Form).find('.warnText').html(warnText);
                } else {
                  if (array.warnText != null) $(array.warnText).html(all);
                  else $(Form).find('.warnText').html(all);
                }
              } else {
                if (resp.length && resp.length !== 'false') {
                  if (array.response) $(array.response).html(resp);
                  else $(Form).closest('div').html(resp);
                } else {
                  if (array.response) $(array.response).html(all);
                  else $(Form).find('div').html(all);
                }
              }
              actions(dataSuccess);
              actions(data);
              mask();
              frame();
              form_validate();
              frame_size();
            },
          });
        }
      },
    });
  });
}
